export enum ModalColorScheme {
    None = 'None',
    Primary = 'Primary',
    Secondary = 'Secondary',
}
